// extracted by mini-css-extract-plugin
export var list = "Responses-module--list--e5c9a";
export var response = "Responses-module--response--6d036";